import type { HackerStatusesShow } from '@/types';
import { CredentialView } from './components/credential/CredentialView';
import { StatusViewHack25 } from './components/StatusViewHack25';

// /hacker/:publicId/status. The server already picked which of the four Next status
// views this is (Hacker::StatusesController).
export default function Show({ variant, statusData }: HackerStatusesShow) {
  if (variant === '25') {
    return <StatusViewHack25 statusData={statusData} />;
  }

  return <CredentialView edition={variant} statusData={statusData} />;
}
